// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bb268743","732":"f636d227","977":"d67bdf99"}[chunkId] + ".chunk.js";
};